<ndt-mailbox-detail-view
   [mailbox]="mailbox$ | async"
   [mailboxPrivileges]="mailboxPrivileges$ | async"
   [extensionPrivileges]="extensionPrivileges$ | async"
   [promptPrivileges]="promptPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (addNewPrompt)="onAddNewPrompt($event)"
   (editMailboxPin)="onEditMailboxPin($event)"
   (clearMailboxClick)="onClearMailbox($event)"
   (resetMailboxClick)="onResetMailbox($event)"
></ndt-mailbox-detail-view>
